import { Component } from 'react';
import { RefreshCw } from 'lucide-react';
import { isReloadPending, reloadNow } from '../lib/chunkReload';

// Oberste Fehlergrenze nur für den Fall „neue Version wird geladen“
// (siehe lib/chunkReload.js). Alle anderen Fehler reicht sie unverändert
// weiter, damit sich am bisherigen Verhalten nichts ändert.
export default class ReloadBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    if (!isReloadPending()) throw error;
    return (
      <div className="min-h-screen bg-page flex items-center justify-center p-6">
        <div className="text-center">
          <p className="text-sm font-semibold text-ink">Neue Version wird geladen…</p>
          <p className="text-xs text-ink-3 mt-1">Die App wurde gerade aktualisiert.</p>
          <button
            type="button"
            onClick={reloadNow}
            className="mt-4 inline-flex items-center gap-2 px-4 py-2 text-xs font-bold text-white bg-brand rounded-md"
          >
            <RefreshCw size={13} aria-hidden="true" />Neu laden
          </button>
        </div>
      </div>
    );
  }
}
